export default "__VITE_ASSET__e44e188a__"